export const modelConstant = {
  FETCH_MODELS_REQUEST: 'FETCH_MODELS_REQUEST',
  FETCH_MODELS_SUCCESS: 'FETCH_MODELS_SUCCESS',
  FETCH_MODELS_FAILURE: 'FETCH_MODELS_FAILURE',
} as const;
